<template>
	<v-card v-can="'order.read'">
		<v-card-title class="d-flex align-center">
			<v-icon
				icon="$basket"
				start
			/>
			<span>
				<translate>Customer overview</translate>:
				<a
					target="_blank"
					:href="`/bo/users/view?id=${user.id}`"
				> {{ formatUserName() }}</a>
			</span>
		</v-card-title>
		<v-card-text v-if="orders.length > 0">
			<v-row
				v-can="'orderrow.read'"
			>
				<v-col>
					<v-data-table
						v-model:expanded="expanded"
						:headers="headers"
						:items="orders"
						:group-by="groupBy"
						:items-per-page="-1"
						item-key="id"
						hide-default-footer
					>
						<template #column.amount>
							<img
								src="/bo/images/icons/lightning_add.png"
								alt="Schade bedragen"
								title="Schade bedragen"
							>
						</template>
						<template #column.data-table-group />
						<template #group-header="{ item, columns, toggleGroup, isGroupOpen }">
							<template v-if="isGroupOpen(item)">
								<tr :class="`${item.items[0].raw.selected ? 'selected' : ''}`">
									<td :colspan="columns.length">
										<a :href="`/bo/orders/view?id=${item.items[0].raw.id}`"><translate>Order</translate> #{{ item.value }}</a>
									</td>
								</tr>
							</template>
							<template v-else>
								{{ toggleGroup(item) }}
							</template>
						</template>
						<template #item.amount="{item}">
							{{ transformToCurrency(item.amount) }}
						</template>
						<template #row-props />

						<template #expanded-row="{item}">
							<tr
								v-for="claim in item.claims"
								:key="claim.id"
								v-can="'claim.read'"
								:class="`${claim.selected ? 'selected' : ''}`"
							>
								<td />
								<td>
									<a :href="`/bo/claims/view?id=${claim.id}`"><translate>Claim</translate> #{{ claim.name }}</a>
								</td>
								<td>
									<template v-if="claim.temporaryReplacementType === 1">
										<img
											src="/bo/images/icons/phone.png"
											:title="$gettext('Client desires use of replacement phone')"
											:alt="$gettext('Client desires use of replacement phone')"
										>
									</template>
									<template v-else-if="claim.temporaryReplacementType === 2">
										<img
											src="/bo/images/icons/phone.png"
											:title="$gettext('Client desires use of replacement phone')"
											:alt="$gettext('Client desires use of replacement phone')"
										>
										<img
											src="/bo/images/icons/arrow_right.png"
											:title="$gettext('Temporary replacement sent to client')"
											:alt="$gettext('Temporary replacement sent to client')"
										>
									</template>
									<template v-else-if="claim.temporaryReplacementType === 3">
										<img
											src="/bo/images/icons/phone.png"
											:title="$gettext('Client desires use of replacement phone')"
											:alt="$gettext('Client desires use of replacement phone')"
										>
										<img
											src="/bo/images/icons/arrow_undo.png"
											:title="$gettext('Temporary replacement was returned by client')"
											:alt="$gettext('Temporary replacement was returned by client')"
										>
									</template>
								</td>
								<td>
									<translate>{{ claim.type }}</translate>
								</td>
								<td>
									{{ transformToCurrency(claim.amount) }}
								</td>
								<td>
									<translate>{{ claim.status }}</translate>
								</td>
								<td>
									{{ claim.startDate }}
								</td>
								<td>
									{{ claim.endDate }}
								</td>
							</tr>
						</template>
						<template #bottom />
					</v-data-table>
				</v-col>
			</v-row>
		</v-card-text>

		<v-card-text v-else>
			<v-row>
				<v-col>
					<em><translate>No orders from this customer.</translate></em>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
import {
	axios,
} from '../../services/axios-service';
import {
	displayError,
} from 'laravel-front-library';
export default {
	name: 'CustomerOverview',
	props: {
		userId: {
			type: Number,
			required: true
		},
		modelName: {
			type: String,
			required: true
		}
	},

	data () {
		return {
			modelId: null,
			user: {
				id: '',
				preamble: '',
				fullName: '',
				dateBirth: ''
			},
			orders: [],
			claims: [],
			groupBy: [
				{
					key: 'orderkey'
				},
			],
			expanded: [],
		};
	},

	computed: {
		headers () {
			return [
				{
					title: '', key: 'name', sortable: false
				},
				{
					title: '', key: 'empty', sortable: false
				},
				{
					title: '', key: 'type', sortable: false
				},
				{
					title: '', key: 'amount', sortable: false
				},
				{
					title: this.$gettext('Status'), key: 'status', sortable: false
				},
				{
					title: this.$gettext('Start'), key: 'startDate', sortable: false
				},
				{
					title: this.$gettext('End'), key: 'endDate', sortable: false
				},
			];
		},
	},

	mounted () {
		this.modelId = Number(new URLSearchParams(window.location.search.substring(1)).get('id'));
		this.getUserData();
		this.getOrders();
	},

	methods: {
		/**
		 * Gets the user data
		 */
		getUserData () {
			axios.get(`/api/v0/users/customer?id=${this.userId}`).then(({
				data
			}) => {
				this.user = data;
			}).catch((error) => {
				displayError(error);
				window.captureException(error);
			});
		},

		/**
		 *
		 */
		getOrders () {
			axios.get(`/api/v0/orders/overview?user_id=${this.userId}`)
				.then(({
					data
				}) => {
					this.orders = data;
					this.orders.forEach((item) => {
						if (this.modelName === 'order' && item.id === this.modelId) {
							item.selected = true;
						} else if (this.modelName === 'claim' && item.claims.length > 0 && item.claims.findIndex(((element) => element.id === this.modelId)) !== -1) {
							item.claims[item.claims.findIndex(((element) => element.id === this.modelId))].selected = true;
						}
						this.expanded.push(item.id);
					});
				}).catch((error) => {
					displayError(error);
					window.captureException(error);
				});
		},

		/**
		 * @returns {string}
		 */
		formatUserName () {
			if (this.user.dateBirth) {
				return this.$gettext(this.user.preamble) + ' ' + this.user.fullName + ' (' + this.user.dateBirth + ')';
			}
			return this.$gettext(this.user.preamble) + ' ' + this.user.fullName;
		},

		/**
		 * @param {string} amount
		 * @returns {string}
		 */
		transformToCurrency (amount) {
			const eurFormatter = new Intl.NumberFormat('nl', {
				style: 'currency',
				currency: 'EUR',
			});

			return eurFormatter.format(Number(amount));
		},
	}
};
</script>
<style scoped>
.selected {
	background: #c4e5b6 !important;
}
</style>
